import { render, staticRenderFns } from "./ContentOverlayBox.vue?vue&type=template&id=91ebe0c2&scoped=true&"
import script from "./ContentOverlayBox.vue?vue&type=script&lang=js&"
export * from "./ContentOverlayBox.vue?vue&type=script&lang=js&"
import style0 from "@/sass/07_elements/content-overlay-box.scss?vue&type=style&index=0&id=91ebe0c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ebe0c2",
  null
  
)

export default component.exports